import { TableStructure } from "../../components/TableStructure";
import { HrSystemLeftMenuList } from "../../utils/constants";

const List = [
  {
    label: "CMP's Circular No.01 / Election of 2023-2024",
    fileStoreId: "d5d5c9d9-2662-4558-80a5-3506753fade1",
    date: "06-April-2023",
    subject:
      "Updation of data of KMC personnel in Election Manpower Management Systen(EMMS) portal",
  },
  {
    label: "CMP's Office Order No. CH.MANAGER(P)/185/RTI of 2022-2023",
    fileStoreId: "b74c8114-539b-4c6e-bb25-27edafa0cf07",
    date: "28-January-2023",
    subject: "State Assistant Public Information Officer, KMC",
  },
  {
    label: "CMP's Circular No.34 / R.Cell of 2022-2023",
    fileStoreId: "d34bb861-180c-4626-9abf-5a7d95054d17",
    date: "16-november-2022",
    subject: "Chif Manger(P)'s Circular No.34 / R.Cell of 2022-2023",
  },
  {
    label: "CMP's Circular No.05/I of 2022-23",
    fileStoreId: "f2bdacb1-6beb-43f4-b918-932bc78318e8",
    date: "19-April-2022",
    subject:
      "GUIDELINES REGARDING SECTION OF SPECIAL LEAVE WITH FULL PAY TO K.M.C EMPLOYEES SUFFERING FROM CENTER, 100% RENAL FAILURE & AIDS",
  },
  {
    label: "CMP's Circular No.56/V/ of 2021-22",
    fileStoreId: "1f96aa70-098b-4871-910e-ed06c7ec666b",
    date: "17-Feb-2022",
    subject:
      "Modalities in respect with new engagement or renewal of Contractual or Casual Employees of KMC.",
  },
  {
    label: "CMP's Circular No.45/VIII of 2021-22",
    fileStoreId: "1d9cd687-99bc-4452-9ba6-e2aa4927406c",
    date: "26-Nov-2021",
    subject:
      "REMOVAL OF ANOMALIES IN THE PAY SCAL OF OFFICERS UNDER KMC LEAGAL SERVICE.",
  },
  {
    label: "CMP's Circular No. 18/VIII of 2021-22",
    fileStoreId: "9c0713b3-f7b7-460e-a838-f8537e2b849a",
    date: "24-June-2021",
    subject: "Addendum to Chief Manager (P)'s Circular No.24/VIII/2020-21.",
  },
  {
    label: "CM(P)'s Circular No. 11 of 2021-22",
    fileStoreId: "1349e0da-47ff-4905-afbb-d0bcc821e120",
    date: "04-Jun-2021",
    subject: `Re-circulation of "The Calcutta Municipal Corporation Officers and Employees (Conduct) Regulations,1991".`,
  },
  {
    label: "Chief Manager(P)'s Circular No.-: 42/VIII/2019-2020",
    fileStoreId: "aba38c4c-35a8-4054-9914-4c61c9b0466d",
    date: "02-Dec-2019",
    subject:
      "Grant of Paternity-cum-Child Care Leave for 30(thirty) days to the male employees of Kolkata Municipal Corporation.",
  },
  {
    label: "Chief Manager (P)'s Circular No. -:19 /VIII of 2019-20",
    fileStoreId: "54e546cb-2dc6-48d9-810d-1fe11305fd00",
    date: "27-August-2019",
    subject:
      "Implementation of modified Recruitment Regulations for the post of Teacher in KMC Primary Schools under Education Department, KMC as approved by Corporation, dated 21.05.2019",
  },
  {
    label: "Chief Manager (P)'s Circular No. -:14 /VIII of 2019-20",
    fileStoreId: "cbaa880d-d925-4cc4-a526-3d29060b2df2",
    date: "09-August-2019",
    subject:
      "Modification of Recruitment Regulations for the post of 'Overseer (SWM)' under SWM-I Department, KMC",
  },
  {
    label: "Chief Manager (P)'s Circular No.62/I of 2018-19",
    fileStoreId: "0dfcf02a-cd41-42d4-86d7-fee00ffa8f5e",
    date: "12-February-2019",
    subject:
      "Modifications in the existing procedure for Issuance of NOC to KMC employees for obtaining Passport",
  },
  {
    label: "Chief Manager (P)'s Circular No.48/VIII of 2018-19",
    fileStoreId: "42e4417a-1cda-4331-bb54-04c13d0d552c",
    date: "26-November-2018",
    subject: "Chief Manager (P)'s Circular No.48/VIII of 2018-19",
  },
];

export const OfficeOrderCircular = () => (
  <TableStructure
    list={List}
    columnNo={3}
    leftMenuList={HrSystemLeftMenuList}
    title="Circular"
    longMenuList={false}
  />
);
